<script setup lang="ts">
/**
 * DS Modal `Header` — Default (324:4807): label/caps title, 44 close on the
 * right, 16 / 4 inset. Mobile (481:28287): grabber row title in body/strong,
 * centred between an optional back button and the close.
 */
import { FairIconButton } from '@/ui/primitives/FairIconButton'

interface FairDialogHeaderProps {
  title?: string
  mobile?: boolean
  closable?: boolean
  showBack?: boolean
  closeLabel?: string
  backLabel?: string
}

withDefaults(defineProps<FairDialogHeaderProps>(), {
  title: 'Header',
  mobile: false,
  closable: true,
  showBack: false,
  closeLabel: 'Close',
  backLabel: 'Back',
})

const emit = defineEmits<{
  close: []
  back: []
}>()
</script>

<template>
  <header
    class="fair-dialog-header"
    :class="{ 'fair-dialog-header--mobile': mobile }"
  >
    <div
      v-if="$slots.start || showBack || mobile"
      class="fair-dialog-header__start"
    >
      <slot name="start">
        <FairIconButton
          v-if="showBack"
          icon="arrow-left"
          :aria-label="backLabel"
          @click="emit('back')"
        />
        <span
          v-else-if="mobile"
          class="fair-dialog-header__spacer"
          aria-hidden="true"
        />
      </slot>
    </div>
    <h2 class="fair-dialog-header__title">
      <slot>
        {{ title }}
      </slot>
    </h2>
    <div
      v-if="$slots.end || closable || mobile"
      class="fair-dialog-header__end"
    >
      <slot name="end" />
      <FairIconButton
        v-if="closable"
        icon="close"
        :aria-label="closeLabel"
        @click="emit('close')"
      />
      <span
        v-else-if="mobile"
        class="fair-dialog-header__spacer"
        aria-hidden="true"
      />
    </div>
  </header>
</template>
